import { ComponentStyleConfig } from "@chakra-ui/react";

const FormErrorTheme: ComponentStyleConfig = {
  baseStyle: {
    text: {
      marginTop: "2px",
      color: "error.600",
      fontSize: "10px",
      position: "absolute",
      width: "100%",
      p: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "&[data-has-help-text]": {
        marginTop: "2px",
        lineHeight: "unset",
        position: "unset",
      },
    },
    icon: {
      mr: "3px",
    },
  },
};

export default FormErrorTheme;
